import type { PublicShopDto } from "@babackapp/private-api-client/types";
import { createContext, use } from "react";

const ShopContext = createContext<PublicShopDto | null>(null);

export const useShop = () => {
  const shop = use(ShopContext);

  if (!shop) {
    throw new Error("useShop must be used within a ShopProvider");
  }

  return shop;
};

export const ShopProvider = ({
  children,
  shop,
}: React.PropsWithChildren<{ shop: PublicShopDto }>) => {
  return <ShopContext.Provider value={shop}>{children}</ShopContext.Provider>;
};
